import axiosService from '../axios.service';

const registrationDataService = {

  get(params) {
    
    let querystring = "";
    
    if (params.sessionDate) {
      querystring += `&sessionDate=${params.sessionDate}`
    }

    if (params.ageGroup) {
      querystring += `&ageGroup=${params.ageGroup}`;
    }

    if (params.accountId) {
      querystring += `&accountId=${params.accountId}`
    }

    if (params.sessionId) {
      querystring += `&sessionId=${params.sessionId}`
    }

    return new Promise((resolve) => {
      axiosService.api.get(`/registration?${querystring}`)
        .then(response => {
          resolve(response.data);
        })
    })
  },
  add(registration) {
    return new Promise((resolve, reject) => {

      axiosService.api.post(`/registration`, registration)
        .then(response => {
          resolve(response);
        }).catch(err => {
          reject(err);
        })
    })
  },
  update(registration) {
    return new Promise((resolve, reject) => {

      axiosService.api.put(`/registration`, registration)
        .then(response => {
          resolve(response);
        }).catch(err => {
          reject(err);
        })
    })
  },
  delete(id) {
    return new Promise((resolve) => {
      axiosService.api.delete(`/registration/` + id)
        .then(response => {
          resolve(response);
        })
    })
  }
}

export default registrationDataService
